import Heading from "../../components/heading";
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AttackSimulator from '../../components/AttackSimulator.jsx'
import { ATTACKS, LANGUAGES } from '../../data.js'
import background from "../../images/blue_background.jpg"
import "./Comparison.css"

export default function C_vector(){
  const [attack, setAttack] = useState(null)
  const [language, setLanguage] = useState(null)
  const [attackIndex, setAttackIndex] = useState(0)
  const nav = useNavigate()

  const simulate = () => {
    const nextAttack = ATTACKS[attackIndex]
    setAttack(nextAttack)
    setAttackIndex((prevIndex) => (prevIndex + 1) % ATTACKS.length)
  }

  const goCompare = () => {
    const q = attack ? `?attack=${encodeURIComponent(attack.name)}` : ''
    nav(`/comparison${q}`)
  }

  // Where the selected card sits in the row, as a % from the left (e.g. the
  // middle card of 5 is 50%). The spotlight grows out of that spot.
  const selectedIndex = ATTACKS.findIndex(a => a.name === attack?.name)
  const originX = `${((selectedIndex + 0.5) / ATTACKS.length) * 100}%`

  return (
    <>
    <div style={attack ? { "--attack-color": attack.color } : {}}>
    <Heading attack={attack} />

    <main className="comp_container">

        <div className="bg-overlay"></div>
      <img src={background} alt="city scape" className="bg-image"></img>

      <section className="panel">
        <header className="site-header">
          <h1>What It Protects Against</h1>
          <p className="tagline"></p>
        </header>
        <h2> Attack types & examples</h2>

        {/* The spotlight: the selected attack's full description, shown above the row.
            The key changes with each attack, so the animation plays again every time. */}
        <div
          key={attack ? attack.name : "none"}
          className="attack-spotlight"
          style={attack ? { "--origin-x": originX } : {}}
        >
          {attack ? (
            <>
              <h3>{attack.name}</h3>
              <p>{attack.expanded}</p>
            </>
          ) : (
            <p className="example">Press <strong>Simulate Attack</strong> to see how each attack works.</p>
          )}
        </div>

        <div className="attacks">
          {ATTACKS.map(a => (
            <article
              key={a.name}
              className={`attack ${attack ? "has-selection" : "" } ${attack?.name === a.name ? "selected" : "unselected"}`}
              style={attack?.name === a.name ? { "--attack-color": a.color } : {}}
            >
              <h3>{a.name}</h3>
              <p className="example">{a.example}</p>
            </article>
          ))}
          
        </div>
        
      {/* <p>Only one language is shown at a time. Languages are randomly assigned together with an attack when you press <strong>Simulate Attack</strong>.</p> */}

        <AttackSimulator  attack={attack} language={language} onSimulate={simulate} />

        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button onClick={goCompare} className="next"> next </button>
        </div>
      
      </section>

      <footer className="demo-footer">
        <small>DEMONSTRATION ONLY</small>
      </footer>
    </main>
    </div>
    </>

  )
}
